import type { TaxonomyMetadata } from '../modules/taxonomy/types';

export type FilterOptions = {
  categories: string[];
  sources: string[];
  subCategories: string[];
  types: string[];
};

export const mapTaxonomyFilters = (metadata: TaxonomyMetadata[]) => {
  const filters = metadata.reduce(
    (acc, { segment_category, segment_source, segment_sub_category, segment_type }) => {
      segment_category && acc.categories.push(segment_category);
      segment_source && acc.sources.push(segment_source);
      segment_sub_category && acc.subCategories.push(segment_sub_category);
      segment_type && acc.types.push(segment_type);

      return acc;
    },
    { categories: [], sources: [], subCategories: [], types: [] } as FilterOptions
  );

  filters.categories = [...new Set(filters.categories)];
  filters.sources = [...new Set(filters.sources)];
  filters.subCategories = [...new Set(filters.subCategories)];
  filters.types = [...new Set(filters.types)];

  return filters;
};
